/** IndexedDB store names. */
export enum Stores {
    Features = 'features'
}
